import { BoardJSON } from '@fry/boards/lib';
import { BaseModel } from '@fry/lib/store';

// This should be typed as the DashboardDoc type so we have type definitions
// See AsyncTasks for example

// This should be just data storage, no logic,
// working with the data should be done in the editor or service

export const enum DashboardTypes {
  dashboard = 'dashboard',
  summary = 'summary'
};
export type DashboardType = keyof typeof DashboardTypes;

export interface DashboardDoc {
    _id: string
    _rev?: string
    type: 'dashboard'

    name: string
    roles: string[] // IDs of roles from RolesStore (allWithSystem())
    usedFor: DashboardType[]
    board: BoardJSON
    translationInfo?: {}
    //translatedTo: string
}

export class Dashboard extends BaseModel<DashboardDoc> {

  public static USED_FOR_DEFAULT: DashboardType[] = [
    DashboardTypes.dashboard,
    DashboardTypes.summary
  ];

  public static USED_FOR_VALUES: Record<'id'|'name', string>[] = [
    { id: DashboardTypes.dashboard, name: 'Dashboard' },
    { id: DashboardTypes.summary, name: 'Summary' },
  ]
}
